import PageHome from "app/(home)/page";
import PageContact from "app/(others)/contact/page";

import ApplyForJob from "app/(others)/ApplyJob/ApplyForJob";
import SignUp from "app/(others)/SignUp/SignUp";
import PageAbout from "app/about/page";
import PageCareers from "app/Careers/Careers";
import LegalPage from "app/Legal/LegalPage";
import PrivacyPolicyLanding from "app/Legal/LegalPages/PrivacyPolicyLanding";
import TermsAndConditionsLanding from "app/Legal/LegalPages/TermsAndConditionsLanding";
import Page404 from "app/not-found";
import PagePlans from "app/Plans/Plans";
import ForeignExchangePage from "app/Services/ForeignExchangePage";
import OnlineBankingPage from "app/Services/OnlineBankingPage";
import PaymentPage from "app/Services/PaymentPage";
import SiteHeader from "app/SiteHeader";
import Footer from "components/Footer/Footer";
import MusicPlayer from "components/MusicPlayer/MusicPlayer";
import React from "react";
import { Helmet } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Page } from "./types";

export const pages: Page[] = [
  { path: "/", component: PageHome, title: "FinVue", description: "The Account Built For Businesses" },

  // Finvue pages -------------------------------------------------------
  { path: "/about", component: PageAbout, title: "FinVue - About Us", description: "Learn more about FinVue." },
  { path: "/careers", component: PageCareers, title: "FinVue - Careers", description: "Open Careers available at FinVue." },
  { path: "/payment", component: PaymentPage, title: "FinVue - Payment", description: "Our services and features." },
  { path: "/online-banking", component: OnlineBankingPage, title: "FinVue - Online Banking", description: "Our services and features." },
  { path: "/foreign-exchange", component: ForeignExchangePage, title: "FinVue - Foreign Exchange", description: "Our services and features." },

  { path: "/payment", component: PaymentPage, title: "FinVue - Payment", description: "Our services and features." },
  { path: "/plans", component: PagePlans, title: "FinVue - Plans", description: "Our plans and pricings." },
  { path: "/contact", component: PageContact, title: "FinVue - Contact Us", description: "Contact our dedicated team." },
  { path: "/legal", component: LegalPage, title: "FinVue - Legal", description: "All the legal documents." },
  { path: "/apply", component: ApplyForJob, title: "FinVue - Apply for Job", description: "Apply for Job with us." },
  { path: "/sign-up", component: SignUp, title: "FinVue - Sign Up for an Account", description: "Sign up to open an account with us." },

  { path: "/page404", component: Page404 },

  { path: "/privacy-policy", component: PrivacyPolicyLanding, title: "FinVue - Privacy Policy", description: "Privacy Policy for FinVue." },
  { path: "/terms-and-conditions", component: TermsAndConditionsLanding, title: "FinVue - Terms and Conditions", description: "Terms and Conditions for FinVue." },
];

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <SiteHeader />

      <Routes>
        {pages.map(({ component: Component, path, title, description, keywords }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <>
                <Helmet>
                  <title>{title}</title>
                  {description && <meta name="description" content={description} />}
                  {keywords && <meta name="keywords" content={keywords} />}
                </Helmet>
                <Component />
              </>
            }
          />
        ))}
        <Route path="*" element={<Page404 />} />
      </Routes>

      {/* <Footer /> */}
      {/* <MusicPlayer /> */}
    </BrowserRouter>
  );
};

export default MyRoutes;
